module.exports = __webpack_public_path__ + "img/Yosemite.085681bc.jpg";